export const Brand = ({ name = "D+Photo", className = "" }) => {
  const [a, ...rest] = name.split("+");
  return (
    <span data-testid="brand-name" className={`font-display font-black tracking-tight ${className}`}>
      {rest.length ? (
        <>
          {a}<span className="text-lime-400">+</span><span className="text-cyan-400">{rest.join("+")}</span>
        </>
      ) : name}
    </span>
  );
};
